import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import "@fortawesome/free-brands-svg-icons";
import "@fortawesome/free-brands-svg-icons";
import { faCircleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";

export default function InvoiceFieldsArgentina({
  handleBlurTaxID,
  errors,
  changeStoreField,
  invoiceFields,
  setInvoiceFields,
}) {
  const state = useSelector((state) => state);
  const { t } = useTranslation();

  const { billing, patterns, system_fields } = state.checkoutStore;

  const { doingRequest } = state.ui;

  const [showInvoiceFields, setShowInvoiceFields] = useState(false);
  const [taxIdType, setTaxIdType] = useState("DNI");

  const conditionFrenteAlIvaOptions = [
    { value: "Responsable Inscripto", label: "Responsable Inscripto" },
    { value: "Consumidor Final", label: "Consumidor Final" },
    { value: "Monotributista", label: "Monotributista" },
    { value: "Exento", label: "Exento" },
    { value: "No Responsable", label: "No Responsable" },
  ];

  const taxIdTypeOptions = [
    { value: "DNI", label: "DNI" },
    { value: "CUIL", label: "CUIL" },
    { value: "CUIT", label: "CUIT" },
    { value: "CDI", label: "CDI" },
    { value: "Pasaporte", label: "Pasaporte" },
  ];

  useEffect(() => {
    if (billing && billing.taxid) {
      setShowInvoiceFields(
        billing.taxid.length > 5 && system_fields.invoice_details,
      );
    }
  }, [billing]);

  const handleTaxIdTypeChange = (e) => {
    setTaxIdType(e.target.value.replace(/\s+/g, ""));
    setInvoiceFields({ ...invoiceFields, "Tipo de Documento": e.target.value });
  };

  const getTaxIdPlaceholder = () => {
    let placeholder = "";
    switch (taxIdType) {
      case "CUIT":
      case "CUIL":
      case "CDI":
        placeholder = "XX-XXXXXXXX-X";
        break;
      case "DNI":
        placeholder = "XXXXXXXX";
        break;
      case "Pasaporte":
        placeholder = "";
        break;
      default:
        placeholder = "XX-XXXXXXXX-X";
    }
    return placeholder;
  };

  return (
    <div className="col-6 mb-2 form-group">
      <div
        className={`input-placeholder floating-label-wrap mb-3 ${
          errors.taxid ? "error-div-highlight" : ""
        }`}
      >
        <label htmlFor="taxid" className="label-checkout">
          Datos de facturación
          {system_fields.taxid_required ? "*" : t("information.optional")}
        </label>
        <div className="input-group">
          <Select
            classNamePrefix="custom-select"
            className="taxid-type"
            id="taxid_type"
            isDisabled={doingRequest}
            options={taxIdTypeOptions}
            value={
              taxIdTypeOptions.find((opt) => opt.value === taxIdType) || null
            }
            onChange={(selected) =>
              handleTaxIdTypeChange({
                target: { value: selected ? selected.value : "" },
              })
            }
            onBlur={handleBlurTaxID}
          />
          <input
            type="text"
            required
            className="form-control floating-label-field form-group floating-label-field--s1"
            id="taxid"
            disabled={doingRequest}
            placeholder={getTaxIdPlaceholder()}
            value={(billing != null && billing.taxid) || ""}
            onChange={(e) => changeStoreField("taxid", e.target.value)}
            onBlur={handleBlurTaxID}
          />
        </div>
        {getTaxIdPlaceholder() && (
          <small className="form-text text-muted mt-1">
            Formato: {getTaxIdPlaceholder()}
          </small>
        )}
      </div>
      <div
        className={`field-error ${errors.taxid ? "" : "hidden-error"} mt-n3`}
        style={{
          display: errors.taxid ? "flex" : "",
          alignItems: "center",
        }}
      >
        <FontAwesomeIcon
          icon={faCircleExclamation}
          style={{ paddingRight: "2px" }}
          size="sm"
          fixedWidth
        />
        {t(errors.taxid) +
          (errors.taxid != null
            ? errors.taxid.includes("empty") || errors.taxid.includes("invalid")
              ? ""
              : patterns.taxid_pattern
            : "")}
      </div>

      {(taxIdType === "CUIT" || taxIdType === "CDI") && (
        <>
          <div className="floating-label-wrap form-group mb-3">
            <label htmlFor={"razonsocial"} className="label-checkout">
              Razon Social *
            </label>
            <input
              type="text"
              className="floating-label-field floating-label-field--s1"
              id={"razonsocial"}
              disabled={doingRequest}
              placeholder={"Razon Social"}
              required
              onChange={(e) =>
                setInvoiceFields({
                  ...invoiceFields,
                  "Razon Social": e.target.value,
                })
              }
            />
          </div>

          <div className="floating-label-wrap form-group mb-3">
            <label htmlFor={"conditionFrenteAlIva"} className="label-checkout">
              Condición Frente al IVA *
            </label>
            <Select
              classNamePrefix="custom-select"
              id="conditionFrenteAlIva"
              isDisabled={doingRequest}
              options={conditionFrenteAlIvaOptions}
              placeholder="Seleccione una opción"
              value={
                conditionFrenteAlIvaOptions.find(
                  (opt) =>
                    opt.value === invoiceFields["Condition Frente al IVA"],
                ) || null
              }
              onChange={(selected) =>
                setInvoiceFields({
                  ...invoiceFields,
                  "Condition Frente al IVA": selected ? selected.value : "",
                })
              }
            />
          </div>
        </>
      )}
    </div>
  );
}
